/* eslint-disable */
import React from "react";
import { AppRegistry, Image, StatusBar, TouchableOpacity, View, Alert, Animated, Easing } from "react-native";
import { Container, Content, Text, List, ListItem, Icon, Item, Thumbnail } from "native-base";
import styles from './Styles/SideBarScreenStyle'
import { NavigationActions } from 'react-navigation';
import SwiperActions from '../Redux/SwiperRedux'
import { Routes } from '../Constant';
import IconWithTextComponent from '../Components/IconWithTextComponent'
import { Images } from '../Themes/'
import { SvgX, Svg } from '../Components/SvgComponent'
import { connect } from 'react-redux'
import { NativeEventEmitter, NativeModules } from 'react-native'; // for catching camera events to lock/unlock scroll

class SideBarScreen extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      spinValue: new Animated.Value(0),
      iconX: false,
      camIsScroll: true
    }
    // subscribe to events from camera like lock main side swipe or not
    const { CameraEventManager } = NativeModules;
    const eventEmitter = new NativeEventEmitter(CameraEventManager);
    // this is working, whew (at least it is getting called from RNCameraManager.m)
    const onEventFromCam = (event) => {
          console.log("SideBarScreen onEventFromCam event = " + JSON.stringify(event) + " mounted = " + this.state.mounted)

          const flag = event.scrollEnabled === "1" ? true : false
          this.setState({ camIsScroll: flag })
    }
    const subscription = eventEmitter.addListener('', onEventFromCam.bind(this));
  }
  resetRoute = (data) => {
    this.props.drawerMethods.closeDrawer()
    const { dispatch, navigate } = this.props.navigation

    if (data == "camera") {
      // if camera has locked side scroll since it is already processing, put up an alert if user press big round Post button
      if (!this.state.camIsScroll) {
        Alert.alert(
            '',
            'Hey, please wait for your last post to finish processing before you get back into the camera.  Thanks!',
            [
              {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
            ],
            { cancelable: true }
        )
        return // dont go to cam
      }
      this.props.changeIndex({ indexChange: 0 })
    } else {
/*
      if (data == "messages"||data == "profilewallv2") {
        navigate(data,{})
      }else{
        const resetAction = NavigationActions.replaceWithAnimation({
          routeName: data, params: { isScroll: data == "home" ? true : false }
        })
        dispatch(resetAction)
      }
*/

      const params = data == "messages" || data == "profilewallv2" ? {} : { isScroll: (data == "home"||data=="explora") ? true : false }
      this.props.navigation.dispatch(NavigationActions.reset({
          index: 0,
          key: null,
          actions: [NavigationActions.navigate({ routeName: data, params: params })]
      }))
    }

  }
  _open = () => {
    // First set up animation
    // Animated.timing(
    //   this.state.spinValue,
    //   {
    //     toValue: 0.25,
    //     duration: 2000,
    //     easing: Easing.linear
    //   }
    // ).start()

  }
  _closed = () => {
    this.setState({ spinValue: new Animated.Value(0) })
  }


  render() {
    let { spinValue } = this.state;
    // Second interpolate beginning and end values (in this case 0 and 1)
    const spin = this.state.spinValue.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '360deg']
    })
    return (
      <Container style={styles.container}>
        <View style={styles.closeIconView} >
          <Animated.View style={{ transform: [{ rotate: spin }] }}>
            <TouchableOpacity
              activeOpacity={1}
              style={styles.closeIcon}
              onPress={() => this.props.drawerMethods.closeDrawer()}>
              <SvgX size={22} />
            </TouchableOpacity>
          </Animated.View>
        </View>

        <Content scrollEnabled={false} contentContainerStyle={styles.content}>
          {Routes.map((data, index) => {
            return (
              <IconWithTextComponent
                isSVG
                key={index}
                type={data}
                onPress={() => this.resetRoute(data)}
              />)
          })}
        </Content>
      </Container>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),

  }
}

export default connect(null, mapDispatchToProps)(SideBarScreen)
